<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">M<span class="smallcaps">Y </span>B<span class="smallcaps">RILLIANT </span>F<span class="smallcaps">RIEND</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// neapolitan-novels-boxed-set_00001.vue?4f77e4ce